module.exports = __webpack_public_path__ + "img/whatsapp-call.71274e2b.svg";